<template>
    <input v-if="type == 'input'" :type="_inputType" :id="id" :class="classes" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
    <textarea v-else-if="type == 'textarea'" :id="id" :class="classes" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"></textarea>
    <select :id="id" :class="classes" @change="$emit('update:modelValue', $event.target.value)" v-else-if="type == 'select'">
        <option v-for="option in options" :value="option.value">{{ option.label }}</option>
    </select>
</template>

<script>
    export default {
        props: ['modelValue', 'type', 'id', 'options', 'inputType'],

        emits: ['update:modelValue'],

        data() {
            return {
                classes: "border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm",
                _inputType: this.inputType ?? 'text'
            };
        },

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>